import debounce from "lodash/debounce"

export default {
  middleware ({ route, redirect, app }) {
    const { query } = route
    if (!query.page)
      return redirect(app.localePath(route.path), { ...query, page: 1 })
  },

  async fetch () {
    await this.filter()
  },

  data () {
    return {
      paginator: {},
      filters: { ...this.$route.query },
      // checkboxFilters: [],
    }
  },

  computed: {
    isResetVisible () {
      return Object.keys(this.filters).filter(k => k !== "page").length
    },

    params () {
      const { filters } = this
      const filtersObj = Object.fromEntries(Object.entries(filters)
        .filter(e => e[0] !== "page")
        .map(e => [`filter[${e[0]}]`, e[1]]))
      return { "paginator[page]": filters.page, ...filtersObj }
    },
  },

  mounted () {
    this.$watch("filters", this.onFiltersChange, { deep: true })
    this.$watch("$route.query", this.onQueryChange, { deep: true })
  },

  methods: {
    // async filter() {},

    onFiltersChange: debounce(function (filters) {
      const { checkboxFilters } = this
      const cleanFilters = Object.fromEntries(Object.entries(filters)
        .filter((e) => {
          if (checkboxFilters && checkboxFilters.includes(e[0]) && !e[1])
            return false
          return e[1] !== ""
        }))
      this.$router.push({ query: cleanFilters })
    }, 300),

    async onQueryChange (query) {
      this.filters = { ...query }
      await this.filter()
    },

    resetFilters () {
      this.filters = {}
    },
  },
}
